<div class="main-content">
  <div class="d-flex p-4 justify-content-between">
    <div class="col-md-8">
      <div class="card">
        <div class="card-header mx-3">
          <h5 class="title">Edit Profile</h5>
        </div>
        <div class="card-body">
          <ov-suite-form #form (formChange)="detectChanges($event)" [formClass]="profileForm" [data]="userData" [showSave]="false">
          </ov-suite-form>
        </div>
      </div>
    </div>
    <div class="col-md-4">
      <div class="card card-user">
        <div class="image"></div>
        <div class="card-body">
          <div class="author">
            <div class="fileinput fileinput-new text-center" data-provides="fileinput">
              <div class="fileinput-new thumbnail img-circle">
                <!--                <img id="uploadedImage" *ngIf="!!user?.avatarUrl" [src]="user.avatarUrl" alt="..." />-->
                <!--                <img id="uploadedImage" *ngIf="!user?.avatarUrl" src="./assets/img/placeholder.jpg" alt="..." />-->
                <img id="uploadedImage" [src]="avatarUrl" alt="..." />
              </div>
              <div class="fileinput-preview fileinput-exists thumbnail img-circle"></div>
              <div>
                <span class="btn btn-round btn-rose btn-file">
                  <span class="fileinput-new">Set Photo</span>
                  <input type="file" name="..." (change)="onFileUpload($event)" />
                </span>
                <br />
                <a class="btn btn-danger btn-round fileinput-exists" data-dismiss="fileinput"
                  ><i aria-hidden="true" class="fa fa-times"></i> Remove</a
                >
                <br />
                <h5 class="title">
                  {{ user.firstName + ' ' + user.lastName }}
                </h5>
              </div>
            </div>
            <hr />
            <div>
              <h6>Domains</h6>
              <p *ngFor="let domain of domainService.allDomains.value">
                {{ domain.name }} {{ currentDomainId == domain.id ? '(current)' : '' }}
              </p>
              <p *ngIf="!domainService.allDomains.value.length">none</p>
            </div>
            <div class="row" *ngIf="canUpdateProfile">
              <div class="col-md-12">
                <hr />
                <button
                  [disabled]="loading"
                  (click)="onSave()"
                  [ngClass]="detect.newChanges.length > 0 ? 'btn-success' : 'btn-default'"
                  class="btn btn-round btn-block"
                >
                  SAVE & UPDATE
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
